import axios from '@/axios';
import jwt from '@/http/requests/auth/jwt';

export default {
  fetchHubspotSettings(_context, data) {
    return axios.get('/api/v1/hubspot/get-hubspot-settings', data);
  },
  fetchHubspotSetting(_context, id) {
    return axios.get('/api/v1/hubspot/get-hubspot-setting/' + id);
  },
  createHubspotSetting(_context, data) {
    return axios.post('/api/v1/hubspot/create-hubspot-setting', data);
  },
  updateHubspotSetting(_context, data) {
    return axios.post(
      '/api/v1/hubspot/update-hubspot-setting/' + data._id,
      data
    );
  },
  deleteHubspotSetting(_context, id) {
    return axios.delete('/api/v1/hubspot/delete-hubspot-setting/' + id);
  },
  getSupplierList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpSupplierList(data)
        .then(res => {
          console.error('get suppliers', res);
          return resolve(res);
        })
        .catch(err => {
          console.error('get error', err);
          return reject(err);
        });
    });
  },
  getAllSupplierList() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpAllSupplierList()
        .then(res => {
          console.error('get suppliers', res);
          return resolve(res);
        })
        .catch(err => {
          console.error('get error', err);
          return reject(err);
        });
    });
  },
};
